import React from "react"
import { useTelegramInitParams } from "./init-params"
import { useTelegramStartParams } from "./start-params"
import { useTelegramUser } from "./user"

export const useTelegram = () => {
  const init = useTelegramInitParams()
  const start = useTelegramStartParams(init.params)
  const user = useTelegramUser(init.params)

  return React.useMemo(() => ({ init, start, user }), [init, start, user])
}

